export const API_URL = process.env.REACT_APP_API_URL;

export function getPriceAPIUrl() {
    return API_URL + '/coin/prices';
}

